export default __webpack_public_path__ + "static/media/hydrocarbon-icon.677d58ea.svg";